var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AgencyService } from './../api/agency.service';
import { OnInit, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OpenModalService } from './shared/modals/open-modal.service';
import { BaseComponent } from './base-component';
var AboutUsBaseComponent = /** @class */ (function (_super) {
    __extends(AboutUsBaseComponent, _super);
    function AboutUsBaseComponent(injector, agencyService, route, openModalService) {
        var _this = _super.call(this, injector) || this;
        _this.agencyService = agencyService;
        _this.route = route;
        _this.openModalService = openModalService;
        _this.agents = [];
        return _this;
    }
    AboutUsBaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.data.forEach(function (data) {
            _this.validateRouteDataParams(data, ['agents', 'web_page']);
            _this.agents = data.agents;
            _this.webPage = data.web_page;
            _this.setTitle('Despre ' + _this.agencyService.agency.name);
            _this.setMetaDescription(_this.webPage.html);
        });
    };
    AboutUsBaseComponent.prototype.openAgentModal = function (agent) {
        this.openModalService.showDetailsModal(agent.full_name, agent.job, agent.description, agent.avatar);
    };
    return AboutUsBaseComponent;
}(BaseComponent));
export { AboutUsBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/about-us-base.component.ts.pre-build-optimizer.js